import BitmapBaseValue from 'core/display/context/texts/BitmapBaseValue'
import { gsap } from 'gsap'
import { FormatService } from 'services/FormatService'
import { signal } from 'services/SignalsService'

export default class LineWinTextCurrency extends BitmapBaseValue{
  constructor(data) {
    super(data)

    this.winModel = game.models.WinModel.get()
    this.tween = { value: 0 }

    signal.on('LINES:HIDE', this.reset.bind(this))
    signal.on('ACTION:WIN-SMALL', this.totalWin.bind(this))
    signal.on('STATE:OUT:WIN', this.byOne.bind(this))
    signal.on('STATE:OUT:BET', this.stopByOne.bind(this))
    signal.on('ACTION:EXPANDING-WILD', this.reset.bind(this))
    signal.on('ACTION:REEL-SPIN', this.reset.bind(this))
  }

  onUpdate() {
    const value = FormatService.currency(this.tween.value, false).split('.').join(',')
    super.update(value)
  }

  totalWin() {
    const value = this.tween.value + this.winModel.linesWin
    if(this.winModel.linesWin === 0){
      this.visible = false
    }
    if (this.checkRegularWin()) {
      signal.dispatch('SOUND:TOTAL:IN')
    }
    if (this.checkRegularWin()) {
      this.visible = true
      const totalWinTween  =  gsap.to(this.tween, 1.2, {
        value,
        onUpdate: () => {
          this.onUpdate()
        },
        onComplete: () => {
          totalWinTween.kill()
          signal.dispatch('SOUND:TOTAL:OUT')
        },
      })
    }
    else {
      this.visible = false
    }

  }

  checkRegularWin() {
    return game.models.BetModel.getValue() < game.models.WinModel.get().totalWin
  }

  byOne() {
    const freeSpinModel = game.models.FreespinModel.get()
    if(freeSpinModel.left) {
      return
    }
    signal.on('LINES:SHOW', this.lineWin.bind(this))
  }

  stopByOne() {
    signal.off('LINES:SHOW', this.lineWin.bind(this))
    this.reset()
  }

  lineWin(id) {
    if (this.checkRegularWin()) {
      this.visible = true
      const line = this.winModel.winLines.find((item) => item.id === id)
      const value = FormatService.currency(line.win, false).split('.').join(',')
      super.update(value)
      const scaleTween = gsap.to(this.text.scale, 0.2, {
        x: 1.2, y: 1.2, onComplete: () => {
          scaleTween.kill()
          const scaleTweenUp = gsap.to(this.text.scale, 0.2, {
            x: 1, y: 1, onComplete: () => {
              scaleTweenUp.kill()
            },
          })
        },
      })
    }
    else {
      this.visible = false
    }
  }

  reset() {
    gsap.killTweensOf(this.tween)
    this.tween.value = 0
    this.visible = true
    signal.dispatch('SOUND:TOTAL:OUT')
    super.update('')
  }
}
